module.exports = __webpack_public_path__ + "img/navia Logo.f0887c13.png";